import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getGuaranteeMoneyBalanceInformationForOrganization = async (
  instance: AxiosInstance,
  params: DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getGuaranteeMoneyBalanceInformationForOrganization(params)
}

// Do Not Remove this line ===@import api client===
